import type { PayloadAction } from '@reduxjs/toolkit';
import type { EditorState } from './state';
import type { QuizCtaSettings } from '@/components/quiz-runtime/quizCta';
import { withQuizCta } from './appearanceEdits';

/**
 * Главная кнопка квиза своими полями (слово владельца 21.10.2026): тело
 * действия `setQuizCta`. Правка одного поля не трогает соседние; `undefined`
 * снимает поле — «как в стиле»; снято последнее или пришёл `null` — поля
 * `quizCta` в настройках нет вовсе (отсутствие = кнопка пака).
 *
 * Живёт здесь, а не в editorSlice.ts: фасад держит храповик длины (WEB-2552).
 * Создатель действия и регистрация — `./screenFieldActions.ts`, имя
 * `editor/setQuizCta`. Правило правки — `withQuizCta` (`./appearanceEdits.ts`,
 * WEB-3767).
 */
export type QuizCtaPatch = {
  [K in keyof QuizCtaSettings]?: QuizCtaSettings[K] | undefined;
};

export function setQuizCtaReducer(
  state: EditorState,
  action: PayloadAction<QuizCtaPatch | null>,
): EditorState {
  return {
    ...state,
    settings: withQuizCta(state.settings, action.payload),
    isDirty: true,
  };
}
